export default "__VITE_ASSET__db61d3e7__"